import _definePage_default_0 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/404.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/battles.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/comms.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/loadout.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/codex.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/homepage/index.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/portal-preview.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/index.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/mobile/leaderboard.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/mobile/loadout.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/index.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/mobile/mystics.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/mobile/nexus.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/404',
    name: '404',
    component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/404.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/base',
    /* internal name: 'base' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'Base',
        component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/index.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
      {
        path: 'mobile',
        /* internal name: 'base-mobile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '/base/mobile-battles',
            name: 'BaseMobileBattle',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/battles.vue'),
            /* no children */
          },
  _definePage_default_3
  ),
  _mergeRouteRecord(
          {
            path: '/base/mobile-comms',
            name: 'BaseMobileComms',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/comms.vue'),
            /* no children */
          },
  _definePage_default_4
  ),
  _mergeRouteRecord(
          {
            path: '/base/mobile-loadout',
            name: 'BaseMobileLoadout',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/base/mobile/loadout.vue'),
            /* no children */
          },
  _definePage_default_5
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/codex',
    name: 'Codex',
    component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/codex.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/homepage',
    /* internal name: 'homepage' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'Homepage',
        component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/homepage/index.vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/portal-preview',
    name: 'PortalPreview',
    component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/portal-preview.vue'),
    /* no children */
  },
  _definePage_default_8
  ),
  {
    path: '/ranks',
    /* internal name: 'ranks' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'Social',
        component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/index.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
      {
        path: 'mobile',
        /* internal name: 'ranks-mobile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '/ranks/mobile-leaderboard',
            name: 'RanksMobileLeaderboard',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/mobile/leaderboard.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
  _mergeRouteRecord(
          {
            path: '/ranks/mobile-loadout',
            name: 'RanksMobileLoadout',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/ranks/mobile/loadout.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  {
    path: '/stake',
    /* internal name: 'stake' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'Stake',
        component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/index.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'mobile',
        /* internal name: 'stake-mobile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '/stake/mobile-mystics',
            name: 'StakeMobileMystics',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/mobile/mystics.vue'),
            /* no children */
          },
  _definePage_default_13
  ),
  _mergeRouteRecord(
          {
            path: '/stake/mobile-nexus',
            name: 'StakeMobileNexus',
            component: () => import('/Users/benji/TESUJI/engineering/vrumble-nft-web/src/pages/stake/mobile/nexus.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

